import { render, staticRenderFns } from "./metrics.vue?vue&type=template&id=5bf72f87&scoped=true"
var script = {}
import style0 from "./metrics.vue?vue&type=style&index=0&id=5bf72f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf72f87",
  null
  
)

export default component.exports